import React from 'react';
import { Link } from 'react-router-dom';
import Profile from '../../Models/Profile';
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};
class AffiliatorSidebar extends React.Component {
    constructor(props) {
        super(props);
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            _id: false,
            minHeight: "475px",
            modalIsOpen: false,
            user: logged_user,
            profession: '',
            photo_id: null,
            utility: null,
            residential: [],
            services: [],
            portfolio: [],
            sex: [],
            area: '',
            address: '',
            x: '',
            profile_picture: null,
            profile: [],
            username: '',
            phone: '',
            email: '',
            creditcard: '',
            t_account: ''
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        Profile.getResidentials().then(res => {
            if (res.data.area != null) {
                this.setState({ residential: res.data.area })
            }
        })
        Profile.getSex().then(res => {
            if (res.data.sex != null) {
                this.setState({ sex: res.data.sex })
            }
        })
        Profile.getBasics(this.state.user.id).then(res => {
            if (res.data.payloads != null) {
                this.setState({ profile: res.data.payloads })
                this.setState({ profession: res.data.payloads.profession })
                this.setState({ photo_id: res.data.payloads.pid })
                this.setState({ profile_picture: res.data.payloads.img })
                this.setState({ utility: res.data.payloads.ut })
                this.setState({ x: res.data.payloads.sex })
                this.setState({ area: res.data.payloads.residential_area })
                this.setState({ address: res.data.payloads.address })
            }
        })
        Profile.getConfiguration(this.state.user.id).then(res => {
            if (res.data.payload != null) {
                this.setState({ username: res.data.payload.first_name })
                this.setState({ phone: res.data.payload.phone })
                this.setState({ email: res.data.payload.email })
                this.setState({ creditcard: res.data.payload.credit_card })
                this.setState({ t_account: res.data.payload.transfer_account })
            }
        })
    }

    handleLogout(e) {
        e.preventDefault();
        window.localStorage.removeItem('info')
        localStorage.clear();
        window.location.href = '/';
    }

    profilePic() {
        var x = JSON.parse(localStorage.getItem('info'))
        if (localStorage.getItem('pro_pic')) {
            var pro_pic = JSON.parse(localStorage.getItem('pro_pic'))
            return (
                <div style={{ height: '170px', marginLeft: '-17px', marginRight: '20px' }}>
                    <img className="" alt="" src={pro_pic} style={{ width: "60%", height: "150px", objectFit: 'cover' }} />
                </div>
            )
        } else {
            return (
                <div style={{ height: '170px', marginLeft: '-17px', marginRight: '20px' }}>
                    <img className="" alt="" src={x.img_sidebar} style={{ width: "60%", height: "150px%", objectFit: 'cover' }} />
                </div>
            )
        }
    }

    profileName() {
        var x = JSON.parse(localStorage.getItem('info'))
        if (localStorage.getItem('pro_name')) {
            var pro_name = JSON.parse(localStorage.getItem('pro_name'))
            console.log(pro_name)
            return (
                <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                    <span className="profile_name">{pro_name}</span>
                </div>
            )
        } else {
            return (
                <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                    <span className="profile_name">{this.state.user.first_name}</span>
                </div>
            )
        }
    }

    render() {
        var x = JSON.parse(localStorage.getItem('info'))
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div className="">
                    {this.profilePic()}
                    <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="profile_name"> {x.first_name} </span>
                    </div>
                    <Link to={{
                        pathname: 'affiliator-my-profile'
                    }} className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="blue_text content_dertails">プロフィール</span>
                    </Link>
                </div>
            )
        }
        else if (isDesktop) {
            return (
                <div>
                    {this.profilePic()}
                    {this.profileName()}
                    {/* <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="profile_name"> {x.first_name} </span>
                    </div> */}
                    <Link to={{
                        pathname: 'affiliator-my-profile'
                    }} className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="blue_text content_dertails">プロフィール</span>
                    </Link>
                    <div className="mt-3  input_name content_dertails guide_text" style={{ width: '85%', marginLeft: '10px' }}>
                        アフィリエイターメニュー
                    </div>
                    <div className="bigger_pad">
                        <table className="sidebar_table">
                            <tbody>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/affiliator-dashboard'} className="color_alt sidebar_font" >ダッシュボード</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/affiliator-create-service-link'} className="color_alt sidebar_font" >アフィリエイトリンク作成</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/affiliator-individual-products'} className="color_alt sidebar_font" >アフィリエイト商品一覧</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/affiliator-sales-management'} className="color_alt sidebar_font" >アフィリエイト報酬</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/affiliator-mlm-tree'} className="color_alt sidebar_font" >ヒエラルキー</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/affiliator-management'} className="color_alt sidebar_font" href=".">アフィリエイター管理</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/affiliator-my-points'} className="color_alt sidebar_font" >振込申請</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="mt-3 input_name content_dertails guide_text" style={{ width: '85%', marginLeft: '10px' }} >
                        購入者メニュー
                </div>
                    <div className="bigger_pad">
                        <table className="sidebar_table">
                            <tbody>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/affiliator-buyer-transaction'} className="color_alt sidebar_font" >購入取引</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>

                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/affiliator-buyer-request-home'} className="color_alt sidebar_font" >リクエスト</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/affiliator-purchase-list'} className="color_alt sidebar_font" >購入一覧</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/affiliator-favorites'} className="color_alt sidebar_font" >お気に入り</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/affiliator-followers-buyer'} className="color_alt sidebar_font" >フォロー</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {/* <hr /> */}
                    <div className="bigger_pad">
                        <table className="sidebar_table">
                            <tbody>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/affiliator-direct-message-list'} className="color_alt sidebar_font" >メッセージ</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/affiliator-change-password'} className="color_alt sidebar_font" >パスワード変更</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/'} onClick={this.handleLogout.bind(this)} className="color_alt sidebar_font" >ログアウト</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            )
        }
    }
}
export { AffiliatorSidebar }